module.exports = __webpack_public_path__ + "static/button-sound-off-9fbbe7d020bc454a2423ff176f2e449d.png";